let recaptchaSiteKey = null
let securityKey = null

export const setRecaptchaSiteKey = (key) => {
  if (key) {
    recaptchaSiteKey = key
  }
}

export const setSecurityKey = (key) => {
  if (key) {
    securityKey = key
  }
}

export const getRecaptchaSiteKey = () => recaptchaSiteKey
export const getSecurityKey = () => securityKey
